class GiftSearchPage {
  constructor(host, giftViewerPageUrl) {
    this.loadCount = 0;
    this.initEverything(host, giftViewerPageUrl);
  }

  initEverything(host, giftViewerPageUrl) {
    if (this.loadCount > 10) return;

    if (typeof $ === 'undefined') {
      setTimeout(() => this.initEverything(host, giftViewerPageUrl), 300);
      return this.loadCount++;
    }

    this.selectors = {
      registrySearchPageContainer: "#registry-search"
    }

    this.giftViewerPageUrl = giftViewerPageUrl;

    this.state = {
      loading: false,
      searchPerformed: false,
      searchPhrase: "",
      registryName: "",
      queryParams: {},
      link: "",
      password: "",
      hideInput: false,
      searchResults: [
      ]
    }

    this.client = new RegistryPublicClient(host);
    this.checkQueryParams();
    this.bindSearchPage();
  }

  goToRegistry(e) {
    e.preventDefault();
    const registryId = e.target.dataset.registryId;
    let name = "";
    for (let registry of this.state.searchResults) {
      if (registry.id == registryId) {
        name = registry.attributes.name;
        break;
      }
    }
    const link = `${this.giftViewerPageUrl}?&r=${registryId}`;
    window.location.href = `/pages/search-for-registry?link=${encodeURIComponent(link)}&r=${registryId}&n=${name}`;
  }

  checkQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    this.state.queryParams.link = urlParams.get('link');
    this.state.queryParams.password = urlParams.get('p');
    this.state.registryName = urlParams.get('n');
    this.state.link = urlParams.get('link');
    if (this.state.link && this.state.link != "") {
      this.state.hideInput = true;
    }
  }

  bindSearchPage() {
    const container = $(this.selectors.registrySearchPageContainer);
    if (!container.length) return;

    tinybind.bind(container, {
      data: this.state,
      methods: {
        onFullNameSearch: this.searchByFullName.bind(this),
        onDirectLinkSearch: this.searchByDirectLink.bind(this),
        onGoClick: this.loginToRegistry.bind(this),
        goToRegistry: this.goToRegistry.bind(this)
      }
    })

  }

  searchByFullName() {
    this.state.loading = true;
    this.client.searchWithName(this.state.searchPhrase)
      .then(res => res.json())
      .then(data => {
        this.state.searchResults = data.data
        this.state.searchPerformed = true;
        this.state.loading = false;
      }).catch(console.log)
    // this.state.searchPerformed = true;
  }

  searchByDirectLink() {
    this.state.searchPerformed = true;
  }

  loginToRegistry() {
    window.location.href = this.state.link + `&p=${encodeURIComponent(this.state.password)}`;
  }

}